import React, { Component } from 'react'
import { Button, Col, Row, Label } from 'reactstrap'
import Card from '../../../../comum/components/Card'
import FormInputSimples from '../../../../comum/components/FormInputSimples';
import { FecharFiltro, Filtro } from '../../../../comum/components/Icones';
import { observer } from 'mobx-react';
import FormDatePicker from '../../../../comum/components/FormDatePicker';
import CheckboxField from '../../../../comum/components/CheckboxField';
import moment from 'moment';
import FormInputCurrency from '../../../../comum/components/FormInputCurrency';
import LoadingImage from '../../../../comum/components/LoadingImage';
import NumberFormat from 'react-number-format';

@observer
export default class FiltrosOrcamentoImport extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;

    }

    render() {
        if(process.env.rig) {
            return(
                <div className="filtro-card filtros-cabotagem">
                    <Card className={`area-form pb-0`}>
                        <Row>
                            <FormInputSimples
                                xs={12} sm={12} 
                                onEnter={this.controller.Pesquisar}
                                titulo="Número do BL ou DI"
                                dado={this.controller.numBl}
                                onChange={(event) => this.controller.setNumBl(event.target.value)}
                                alerta={this.controller.mensagemCif}
                            />
                            <Col xs={12} sm={12} md={4} lg={3} xl={2}>
                                <Label>
                                    Valor CIF
                                </Label>
                                <NumberFormat
                                    style={{padding:"11px 6px", width:"100%"}}
                                    allowNegative={false}
                                    thousandSeparator="."
                                    decimalPrecision={2}
                                    decimalSeparator=","
                                    prefix="R$"
                                    value={this.controller.valorCif}
                                    onChange={(event) => this.controller.setValorCif(event.target.value)}
                                    disabled={this.controller.sucessoCif && this.controller.valorCif}
                                />
                            </Col>
                            {/* <FormInputSimples
                                titulo="Valor CIF"
                                onEnter={this.controller.Pesquisar}
                                onChange={(event) => this.controller.setValorCif(event.target.value)}
                                dado={this.controller.valorCif}
                                bloqueado={this.controller.sucessoCif && this.controller.valorCif}    
                                /> */}
                            <FormDatePicker xs={12} sm={12}  date={this.controller.dataRetirada} titulo="Data de retirada" onChange={(event)=>this.controller.setDataRetirada(event)} />
                            <FormInputSimples xs={12} sm={12}  titulo="Referência cliente" dado={this.controller.refCliente} onChange={(event) => setRefCliente(event.target.value)} />
                        </Row>
                        <Row><Col>Para documentos ainda não averbados, todos os valores são previstos.</Col></Row>
                        <Row>
                            <Col className="mb-2">
                                <div className="mb-2">
                                    <CheckboxField
                                        noTitle={true}
                                        className="px-0"
                                        text="Incluir data de retirada no cálculo do valor de armazenagem"
                                        onClick={(event) => this.controller.setCampoPreferencia('incluiData',event)}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://atendimento.teconline.com.br/hc/pt-br/articles/360039866151-Criar-Or%C3%A7amento-de-Importa%C3%A7%C3%A3o"
                                            style={{color:"#00BEDD", marginLeft: "5px"}}
                                        >
                                            [?]
                                        </a>
                                    </CheckboxField>
                                </div>
                                <div className="mb-2">
                                    <CheckboxField
                                        noTitle={true}
                                        className="px-0"
                                        text="Pagar dia de porta"
                                        onClick={(event) => this.controller.setCampoPreferencia('diaPorta',event)}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://atendimento.teconline.com.br/hc/pt-br/articles/360039866151-Criar-Or%C3%A7amento-de-Importa%C3%A7%C3%A3o"
                                            style={{color:"#00BEDD", marginLeft: "5px"}}
                                        >
                                            [?]
                                        </a>
                                    </CheckboxField>
                                </div>
                            </Col>
                            <Col className="mb-2">
                                <div className="mb-2">
                                    <CheckboxField
                                        noTitle={true}
                                        className="px-0"
                                        text="Desova house (direto para o caminhão)"
                                        onClick={(event) => this.controller.setCampoPreferencia('desovaHouse',event)}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://atendimento.teconline.com.br/hc/pt-br/articles/360039866151-Criar-Or%C3%A7amento-de-Importa%C3%A7%C3%A3o"
                                            style={{color:"#00BEDD", marginLeft: "5px"}}
                                        >
                                            [?]
                                        </a>
                                    </CheckboxField>
                                </div>
                                <div className="mb-2">
                                    <CheckboxField
                                        noTitle={true}
                                        className="px-0"
                                        text="Retirada via barcaça"
                                        onClick={(event) => this.controller.setCampoPreferencia('retiradaBarcaca',event)}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://atendimento.teconline.com.br/hc/pt-br/articles/360039866151-Criar-Or%C3%A7amento-de-Importa%C3%A7%C3%A3o"
                                            style={{color:"#00BEDD", marginLeft: "5px"}}
                                        >
                                            [?]
                                        </a>
                                    </CheckboxField>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                        <Col className="col-botoes"  xs={12} sm={12} md={4} lg={4} xl={4}>
                            <Button onClick={this.controller.Pesquisar} className="btn-com-bordas-primary btn-filtrar">
                                Processar
                            </Button>
                        </Col>
                        </Row>
                    </Card>
                </div>
            );
        } else {
            return(
                <div className="filtro-card filtros-cabotagem">
                    <Card className={`area-form pb-0`}>
                        <Row>
                            <FormInputSimples
                                onEnter={this.controller.Pesquisar}
                                className="mb-0"
                                titulo="Número do BL ou DI"
                                dado={this.controller.numBl}
                                onChange={(event) => this.controller.setNumBl(event.target.value)}
                                alerta={this.controller.mensagemCif}
                            />                            
                            <Col className="col-botoes mt-2">
                                <Button onClick={this.controller.Pesquisar} className="btn-com-bordas-primary btn-filtrar">
                                    Processar
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </div>
            );
        }
        
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/FiltrosOrcamentoImport.js